export default "__VITE_ASSET__HRtmna5p__"